import React from 'react'
import BreadCrumb from '../components/BreadCrumb'
import Meta from '../components/Meta';
import { AiOutlineHome, AiOutlineMail } from "react-icons/ai";
import { BiPhoneCall, BiInfoCircle } from "react-icons/bi";
import Container from '../components/Container';


const Contact = () => {
  return (
    <>
      <Meta title={'Contact Us'} />
      <BreadCrumb title='Contact Us'/>
      <Container class1='contact-wrapper py-5 home-wrapper'>
          <div className='row'>
            <div className='col-12'>
              <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9525.505648328332!2d-1.4363389650943765!3d53.354418109409124!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487982c8c22dd0ff%3A0xd8eaabccd0694d73!2sSprings%20Leisure%20Centre!5e0!3m2!1sen!2suk!4v1712879260719!5m2!1sen!2suk" 
              width="600" 
              height="450" 
              className="border-0 w-100" 
              allowfullscreen="" 
              loading="lazy" 
              referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div className='col-12 mt-5'>
              <div className='contact-inner-wrapper d-flex justify-content-between'>
                <div>
                  <h3 className='contact-title'>Contact</h3>
                  <form action='' className='d-flex flex-column gap-15'>
                    <div>
                      <input type='name' className='form-control' placeholder='Name'/>
                    </div>
                    <div>
                      <input type='email' className='form-control' placeholder='Email'/>
                    </div>
                    <div>
                      <input type='mobile' className='form-control' placeholder='Phone Number'/>
                    </div>
                    <div>
                      <textarea name='comment' id='' className='w-100 form-control' cols='30' rows='4' placeholder='Comments'></textarea>
                    </div>
                    <div>
                      <button className='button border-0'>Submit</button>
                    </div>
                  </form>
                </div>
                <div>
                  <h3 className='contact-title mb-4'>Get in touch with us</h3>
                  <div>
                    <ul className='ps-0'>
                      <li className='mb-3 d-flex gap-15 align-items-center'><AiOutlineHome className='fs-5' />
                      <address className='mb-0'>
                        Plot 9, Ajimotokan Estate, Abeokuta Expressway,
                        Dopemu, Lagos.
                      </address>
                      </li>
                      <li className='mb-3 d-flex gap-15 align-items-center'><BiPhoneCall className='fs-5' />
                        <a href='+234 7067856212'>+234 7067856212</a>
                      </li>
                      <li className='mb-3 d-flex gap-15 align-items-center'><AiOutlineMail className='fs-5' />
                        <a href='mailtome@gmail.com'>mailtome@gmail.com</a>
                      </li>
                      <li className='mb-3 d-flex gap-15 align-items-center'><BiInfoCircle className='fs-5' />
                        <p className='mb-0'>Monday - Friday 10 AM - 8 PM</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </Container>
    </>
  )
}

export default Contact